<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Novas Localidades'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap justify-center>
                  <v-flex xs11 sm6>
                    <v-select
                      label='Estado'
                      :items="listaEstados"
                      @change="atualizaCidades($event)"
                      v-model="localidade.ufCidade"
                      item-text="descricao"
                      prepend-icon="dashboard"
                      max-height="400"
                      return-object
                      required
                      autocomplete
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-center>
                  <v-spacer></v-spacer>
                  <v-flex xs6 sm6>
                    <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
                  </v-flex>
                </v-layout>


                <v-layout row wrap justify-center>
                  <v-flex d-block xs12>
                    <!--<v-data-table
                      v-model="listaCidadesSelecionadas"
                      :headers="headers"
                      :items="listaCidades"
                      item-key="id"
                      show-select
                    >
                    </v-data-table>-->
                    <c-checkbox-table
                      :items="listaCidades"
                      v-model="listaCidadesSelecionadas"
                      :headers="headers"
                      :opcoesPaginacao="opcoesPaginacao"
                      :search="search"
                      item-key="id"
                      :selecionarTudo="true"
                      >
                    </c-checkbox-table>
                  </v-flex>
                </v-layout>

                <br><br>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field
                      label='Nome da localidade ou instituição'
                      v-model="localidade.nome"
                      required
                      :rules="regrasBasicas"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field
                      label='CEP'
                      v-if='listaCidadesSelecionadas.length < 2'
                      v-model="localidade.cep"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label="Informações adicionais"
                      v-model="localidade.detalhes"
                      :rows="3"
                      :auto-grow="true"
                      multi-line
                      counter="200"
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarLocalidades(false)" :disabled="!formularioValido">Adicionar</v-btn>
              <v-btn color="primary" text @click="criarLocalidades(true)" :disabled="!formularioValido">Adicionar e Avançar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import CheckboxTable from '@/components/c-checkbox-table'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      search: null,
      headers: [
        { checkbox: true, sortable: false, value: 'checkbox' },
        { text: 'Nome', align: 'center', value: 'nomeCidade' }
      ],
      sortDesc: false,
      itemsPerPage: 5,
      opcoesPaginacao: [ 5, 10, 25, 50, {text: 'Todas', value: -1} ],
      formularioValido: false,
      localidade: {
        nome: '',
        detalhamento: '',
        ufCidade: {}
      },
      contador: 0,
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      listaEstados: [],
      listaCidades: [],
      listaCidadesSelecionadas: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'AbrangenciaProjeto', params: {idProjeto: this.idProjeto}})
      },
      criarLocalidade: function (localidade, avancar) {
        projetos.postLocalidade(this.idProjeto, localidade)
        .then(response => {
          if (this.contador === 1) {
            this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando localidades.' })
            if (avancar === false) {
              this.$router.push({name: 'AbrangenciaProjeto', params: {idProjeto: this.idProjeto}})
            } else {
              this.$router.push({name: 'ArquivosProjeto', params: {idProjeto: this.idProjeto}})
            }
            this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.contador--
          if (this.contador === 0) {
            this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando localidades.' })
          }
        })
      },
      criarLocalidades: function (avancar) {
        this.contador = this.listaCidadesSelecionadas.length
        if (this.contador === 0) {
          this.contador = 1
          let aux = {
            nome: this.localidade.nome,
            cep: this.localidade.cep,
            detalhes: this.localidade.detalhes,
            ufCidade: this.localidade.ufCidade,
            cidade: null
          }
          this.criarLocalidade(aux, avancar)
        } else {
          this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando localidades.' })
          if (this.listaCidadesSelecionadas.length > 1) {
            this.localidade.cep = null
          }
          this.listaCidadesSelecionadas.forEach(item => {
            let aux = {
              nome: this.localidade.nome,
              cep: this.localidade.cep,
              detalhes: this.localidade.detalhes,
              ufCidade: this.localidade.ufCidade,
              cidade: {id: item}
            }
            this.criarLocalidade(aux, avancar)
          })
        }
      },
      atualizaCidades: function (event) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' })
        projetos.getCidades(event.item)
        .then(response => {
          this.listaCidades = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' })
        })
      },
      atualizaListaCidadesSelecionadas: function (cidade) {
        console.log(this.listaCidadesSelecionadas)
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.dataInicioFormatada = this.dates.format(this.projeto.dataInicio)
        this.dataConclusaoFormatada = this.dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' })
      projetos.getEstados(1)
      .then(response => {
        this.listaEstados = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-checkbox-table': CheckboxTable,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// nova-localidade.vue?257cc0b2